import apiService from '@/utils/request';

const URIs = {
  provincias: '/v1/maestras/provincias'
};

export function getProvincias() {
  let urlStr = URIs.provincias;
  return apiService.get(urlStr);
}
